<template>
  <div>
    <v-btn :x-small="xsmall" @click="open = true">
      <v-icon v-if="!value">mdi-plus</v-icon>
      <v-icon class="mr-3" v-else>mdi-folder-outline</v-icon>
      {{
        value ? value == 'root' ? 
          $t('library.library') : value.name : $t('folder.add_to_folder')
      }}
    </v-btn>
    <choose-folder
      @chosen="folderChosen($event)"
      @closed="open = false"
      :visible="open"
      :value="value"
    ></choose-folder>
  </div>
</template>

<script>
import ChooseFolder from "./ChooseFolder.vue"
export default {
  props: ['value', 'xsmall'],
  components: { ChooseFolder },
  data: () => ({
    open: false
  }),
  methods: {
    folderChosen(f) {
      this.$emit('input', f)
      if(f) this.open = false
    }
  }
}
</script>